export const AGENT_TEAM_ROUTE = '/team';
export const AGENT_TEAM_PATH = `${AGENT_TEAM_ROUTE}/:member_id?`;
